import { ReactNode } from "react";
import * as RadixTabs from "@radix-ui/react-tabs";
import styles from "./Tabs.module.css";
import { cx } from "../utils";

export interface TabsProps {
    value: string;
    onValueChange: (value: string) => void;
    children: ReactNode;
    className?: string;
}

interface TabsListProps {
    children: ReactNode;
    className?: string;
}

interface TabsTriggerProps {
    value: string;
    icon?: ReactNode;
    children: ReactNode;
    className?: string;
    disabled?: boolean;
}

interface TabsContentProps {
    value: string;
    children: ReactNode;
    className?: string;
}

const TabsRoot = ({ value, onValueChange, children, className }: TabsProps) => (
    <RadixTabs.Root value={value} onValueChange={onValueChange} className={cx(styles.root, className)}>
        {children}
    </RadixTabs.Root>
);

const TabsList = ({ children, className }: TabsListProps) => (
    <RadixTabs.List className={cx(styles.list, className)}>{children}</RadixTabs.List>
);

const TabsTrigger = ({ value, icon, children, className, disabled }: TabsTriggerProps) => (
    <RadixTabs.Trigger value={value} className={cx(styles.trigger, className)} disabled={disabled}>
        {icon ? <span className={styles.triggerIcon}>{icon}</span> : null}
        <span>{children}</span>
    </RadixTabs.Trigger>
);

const TabsContent = ({ value, children, className }: TabsContentProps) => (
    <RadixTabs.Content value={value} className={cx(styles.content, className)}>
        {children}
    </RadixTabs.Content>
);

export const Tabs = Object.assign(TabsRoot, {
    List: TabsList,
    Trigger: TabsTrigger,
    Content: TabsContent,
});
